import * as React from 'react';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { Field, reduxForm, InjectedFormProps, change } from 'redux-form';
import { IImageData } from 'models/common';
import * as c from 'models/constants';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { IModalAction } from 'models/modal';
import { ISectionData } from 'models/common/sectiondata';
import { IArticleCard } from 'models/magazine/article/articlecard';
import { Modal, Button, WhiteButton, ErrorSummary } from 'components';
import { ImageUpload, PortalInputField } from 'components/FormControls';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { onCloseModalForm } from 'helpers/common';
require('./../../style.css');
require('components/Tabs/style.css');

interface IProps extends InjectedFormProps {
	currentFormValues: ISectionData;
	section: IMagazinePageSection;
	showHeaderCloseButton: boolean;
	index: number;
	baseUrl: string;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	change: any;

	/* functions props */
	saveSection?: (form: IMagazinePageSection, index?: number) => void;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	error: boolean;
	message: any;
	selectedTab: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType9Form extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
			selectedTab: 'link1',
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.searchArticle = this.searchArticle.bind(this);
		this.selectArticle1 = this.selectArticle1.bind(this);
		this.selectArticle2 = this.selectArticle2.bind(this);
		this.selectArticle3 = this.selectArticle3.bind(this);
		this.imageUploadedCallback = this.imageUploadedCallback.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.imageUploadFailed = this.imageUploadFailed.bind(this);
		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
		this.changeTab = this.changeTab.bind(this);
	}

	private setError(error: any) {
		this.setState({
			error: true,
			message: error,
		});
	}

	private clearError() {
		this.setState({
			error: false,
			message: null,
		});
	}

	private changeTab(selectedTab: string) {
		this.clearError();
		this.setState({ selectedTab });
		this.forceUpdate();
	}

	public onSubmit(form: IMagazinePageSection) {
		form.seoImageUrl =
			(form.data.elements[0] as any).imageUrl ||
			(form.data.elements[3] as any).imageUrl ||
			(form.data.elements[6] as any).imageUrl;
		this.props.saveSection(form, this.props.index);
	}

	private closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	private imageUploadedCallback(id: string, href: string, additionalData: string[]) {
		this.clearError();

		const image: IImageData = {
			id,
			href,
		};

		if (additionalData.length > 0) {
			this.props.change(additionalData[0], image.href);
		}

		this.forceUpdate();
	}

	private imageUploadFailed(error: any) {
		if (error) {
			this.setError(error);
			this.forceUpdate();
		}
	}

	private deleteImage(_, additionalData: string[]) {
		this.props.change(additionalData[0], null);
		this.forceUpdate();
	}

	private selectArticle1(data: IArticleCard) {
		this.props.closeModal();
		this.props.change('data.elements[0].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[1].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[2].text', data.addedBy);
	}

	private selectArticle2(data: IArticleCard) {
		this.props.closeModal();
		this.props.change('data.elements[3].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[4].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[5].text', data.addedBy);
	}

	private selectArticle3(data: IArticleCard) {
		this.props.closeModal();
		this.props.change('data.elements[6].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[7].redirectUrl', '/magazine/article/' + data.code);
		this.props.change('data.elements[8].text', data.addedBy);
	}

	private searchArticle(e: any, func: (data: IArticleCard) => void) {
		e.preventDefault();
		this.props.showModal('SearchArticles', {
			selectArticle: func,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
		});
	}

	public render() {
		const { pristine, submitting, handleSubmit, t, showHeaderCloseButton } = this.props;
		const { error, message, selectedTab } = this.state;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<Modal
				title={t('Magazine_Section_Manage_Title') + ' ' + t('Magazine_Section_Type9_Title')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
				modalClass="pageSectionManageWrapper"
			>
				<form onSubmit={handleSubmit(this.onSubmit)}>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<Tabs name="boxes" selectedTab={selectedTab} handleSelect={this.changeTab} tabComponent="div">
						<div className="tabsHolder">
							<TabLink className="tab" to="link1">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}1
							</TabLink>
							<TabLink className="tab" to="link2">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}2
							</TabLink>
							<TabLink className="tab" to="link3">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}3
							</TabLink>
						</div>
						<div className="tabsContent">
							<TabContent for="link1">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="imageUpload1"
												component={ImageUpload}
												imageUploadedCallback={this.imageUploadedCallback}
												imageUploadFailed={this.imageUploadFailed}
												additionalData={['data.elements[0].imageUrl']}
												existingImageUrl={
													this.props.currentFormValues &&
													this.props.currentFormValues.elements[0] &&
													(this.props.currentFormValues.elements[0] as ISectionImageElement).imageUrl
														? (this.props.currentFormValues.elements[0] as ISectionImageElement).imageUrl
														: null
												}
												onDelete={this.deleteImage}
												label={t('Magazine_Section_Manage_Common_Image')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<WhiteButton
												type="submit"
												usage="admin"
												onClick={(event: any) => this.searchArticle(event, this.selectArticle1)}
											>
												{t('Magazine_Section_Manage_Common_SearchArticle')}
											</WhiteButton>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[0].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												readOnly={true}
												autoFocus={true}
												label={t('Magazine_Section_Manage_Common_ArticleUrl')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[1].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[1].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_RedirectUrl')}
											/>
											<Field name="data.elements[2].text" component="input" type="hidden" placeholder="Author" />
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
							<TabContent for="link2">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="imageUpload2"
												component={ImageUpload}
												imageUploadedCallback={this.imageUploadedCallback}
												imageUploadFailed={this.imageUploadFailed}
												additionalData={['data.elements[3].imageUrl']}
												existingImageUrl={
													this.props.currentFormValues &&
													this.props.currentFormValues.elements[3] &&
													(this.props.currentFormValues.elements[3] as ISectionImageElement).imageUrl
														? (this.props.currentFormValues.elements[3] as ISectionImageElement).imageUrl
														: null
												}
												onDelete={this.deleteImage}
												label={t('Magazine_Section_Manage_Common_Image')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<WhiteButton
												type="submit"
												usage="admin"
												onClick={(event: any) => this.searchArticle(event, this.selectArticle2)}
											>
												{t('Magazine_Section_Manage_Common_SearchArticle')}
											</WhiteButton>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[3].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												readOnly={true}
												label={t('Magazine_Section_Manage_Common_ArticleUrl')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[4].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[4].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_RedirectUrl')}
											/>
											<Field name="data.elements[5].text" component="input" type="hidden" />
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
							<TabContent for="link3">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="imageUpload3"
												component={ImageUpload}
												imageUploadedCallback={this.imageUploadedCallback}
												imageUploadFailed={this.imageUploadFailed}
												additionalData={['data.elements[6].imageUrl']}
												existingImageUrl={
													this.props.currentFormValues &&
													this.props.currentFormValues.elements[6] &&
													(this.props.currentFormValues.elements[6] as ISectionImageElement).imageUrl
														? (this.props.currentFormValues.elements[6] as ISectionImageElement).imageUrl
														: null
												}
												onDelete={this.deleteImage}
												label={t('Magazine_Section_Manage_Common_Image')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<WhiteButton
												type="submit"
												usage="admin"
												onClick={(event: any) => this.searchArticle(event, this.selectArticle3)}
											>
												{t('Magazine_Section_Manage_Common_SearchArticle')}
											</WhiteButton>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[6].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												readOnly={true}
												label={t('Magazine_Section_Manage_Common_ArticleUrl')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[7].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="data.elements[7].redirectUrl"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_RedirectUrl')}
											/>
											<Field name="data.elements[8].text" component="input" type="hidden" />
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
						</div>
					</Tabs>
					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<Button type="submit" disabled={pristine || submitting} usage="admin">
									{t('BSPortal_Common_Save')}
								</Button>
							</div>
						</div>
					</ButtonsSection>
				</form>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	const newProps = {
		type: c.MAGAZINE_PAGE_SECTION_TYPE_9,
		data: {
			elements: [
				{
					imageUrl: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
				{
					imageUrl: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
				{
					imageUrl: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
				{
					text: null,
					redirectUrl: null,
				},
			],
		},
	};

	let currentFormValues: any = null;
	if (
		state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION9] &&
		state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION9].values
	) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION9].values.data;
	}

	return {
		initialValues: ownProps.section || newProps,
		currentFormValues,
	};
}

let ManageType9 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION9,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType9Form);

ManageType9 = connect(mapStateToProps, (dispatch) => ({
	change: (field: string, value: string) => dispatch(change(field, value)),
}))(ManageType9);

export { ManageType9 };
